export enum BillingProvider {
  CHARGEBEE = "CHARGEBEE",
  ZENSKAR = "ZENSKAR"
}
